import SaveIcon from '@mui/icons-material/Save';
import TuneIcon from '@mui/icons-material/Tune';
import Box from '@mui/material/Box';
import { FC, useCallback } from 'react';
import { SxProps } from '@mui/material';
import { AppIconButton } from '@client/foundation/design-system/components';
import {
  SignalBlockTarget,
  TemplateType
} from '@server/trading-templates/schemas/input.schema';
import { useWidget } from '../widget.hook';

type FormConfigButtonsProps = {
  templateType: TemplateType;
  timeframeIndex?: number;
  strategyTarget?: SignalBlockTarget;
  onManageTemplates?: () => void;
  showSave?: boolean;
  sx?: SxProps;
};

export const FormConfigButtons: FC<FormConfigButtonsProps> = ({
  templateType,
  sx,
  timeframeIndex,
  strategyTarget,
  onManageTemplates,
  showSave = true,
}) => {
  const { openWidget } = useWidget();
  const effectiveTimeframeIndex = timeframeIndex || 0;

  const handleSaveTemplate = useCallback(() => {
    openWidget({
      type: 'SaveTradingTemplateForm',
      templateType,
      timeframeIndex: effectiveTimeframeIndex
    });
  }, [effectiveTimeframeIndex, openWidget, templateType]);

  const handleManageTemplates = useCallback(() => {
    if (onManageTemplates) {
      onManageTemplates();
      return;
    }

    openWidget({
      type: 'ManageTradingTemplates',
      templateType,
      timeframeIndex: effectiveTimeframeIndex,
      strategyTarget
    });
  }, [
    effectiveTimeframeIndex,
    onManageTemplates,
    openWidget,
    strategyTarget,
    templateType
  ]);

  return (
    <Box
      sx={[
        {
          display: 'flex',
          alignItems: 'center',
          gap: 0.75
        },
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])
      ]}
    >
      {showSave && (
        <AppIconButton
          title="Save template"
          onClick={handleSaveTemplate}
          tone="primary"
        >
          <SaveIcon />
        </AppIconButton>
      )}
      <AppIconButton
        title="Manage templates"
        onClick={handleManageTemplates}
        tone="primary"
      >
        <TuneIcon />
      </AppIconButton>
    </Box>
  );
};
